export const PARC_SITUATION = Object.freeze({
  AUTORISATION: "autorisation",
  REFUS: "refus",
  REJET: "rejet",
});

export const PARC_SITUATION_LABEL = Object.freeze({
  [PARC_SITUATION.AUTORISATION]: "Autorisation",
  [PARC_SITUATION.REFUS]: "Refus",
  [PARC_SITUATION.REJET]: "Rejet",
});
